<template>
  <div class="create_space">
    <div class="px-10 pt-10">
      <span class="text-h5 mb-3 font-weight-bold" style="display: block">
        {{ $t('SPACE.EDIT.COPYWRITING.SPACE_CREATE_MODE') }}
        <br />
      </span>
      <span class="text-descript mb-10" style="display: block">
        {{ $t('SPACE.EDIT.COPYWRITING.HAVING_MUTIPLE_EDITOR') }}
      </span>
      <Async :loading="loading">
        <div class="card-group d-flex flex-wrap justify-start">
          <v-card
            class="mr-8 mb-10 pt-4 pb-4"
            max-width="320"
            v-for="(item, idx) in spaceData"
            :key="idx"
            @click="goTo(item.to)"
          >
            <v-img :src="item.img" height="178px"></v-img>

            <v-card-title>{{ $t(item.titleKey) }}</v-card-title>

            <v-card-subtitle>{{ $t(item.descriptionKey) }}</v-card-subtitle>

            <v-card-actions>
              <template>
                <v-row align="center" justify="end" class="pd-10">
                  <v-btn title class="no-shadow" :ripple="false">
                    {{ $t('SPACE.EDIT.COPYWRITING.USE_NOW') }}
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-row>
              </template>
            </v-card-actions>
          </v-card>
        </div>
        <v-dialog v-model="dialog" :width="dialogWidth">
          <v-card class="preview_container no-shadow">
            <v-row class="ma-0">
              <v-spacer></v-spacer>
              <v-icon @click="closePop">mdi-window-close</v-icon>
            </v-row>
            <v-scale-transition>
              <v-row
                v-if="computedRenderInfoCard != 'free'"
                class="set_detail"
                style="padding: 0 20px"
              >
                <v-form ref="form" @submit.prevent>
                  <h2 style="font-size: 20px" class="pa-4 pb-0 pt-0">
                    {{ $t('SPACE.EDIT.COPYWRITING.ENTER_SPACE_URL') }}
                  </h2>
                  <div class="pa-4 w100p">
                    <div class="d-flex align-center">
                      <span
                        class="text-16 font-weight-bold neutral100--text"
                        style="line-height: 2"
                      >
                        {{ $t('SPACE.EDIT.COPYWRITING.SPACE_NAME') }}
                        <div style="display: inline-block; color: #ff5084">
                          *
                        </div>
                      </span>
                    </div>

                    <div class="w100p text-14px subtitle">
                      <div>
                        {{
                          $t(
                            'SPACE.EDIT.COPYWRITING.SPACE_NAME_CAN_BE_CHANGED_LATER'
                          )
                        }}
                      </div>
                    </div>

                    <SizeBox height="15" />

                    <div class="flex-center">
                      <div class="w100p">
                        <v-text-field
                          :label="$t('SPACE.EDIT.COPYWRITING.ENTER_SPACE_NAME')"
                          counter="30"
                          solo
                          v-model="name"
                          :rules="[
                            (v) => $rules.required(v, '空間名稱不能為空！'),
                            (v) => $rules.maxLength(v, 30)
                          ]"
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                  <div class="pa-4 w100p">
                    <div class="d-flex align-center">
                      <span
                        class="text-16 font-weight-bold neutral100--text"
                        style="line-height: 2"
                      >
                        {{ $t('SPACE.EDIT.WORD.URL') }}
                        <div style="display: inline-block; color: #ff5084">
                          *
                        </div>
                      </span>
                    </div>

                    <div class="w100p text-14px subtitle">
                      <div>
                        {{
                          $t(
                            'SPACE.EDIT.COPYWRITING.ENTER_URL_CANNOT_BE_CHANGED'
                          )
                        }}
                      </div>
                    </div>

                    <SizeBox height="15" />
                    <div class="flex-center">
                      <div class="w100p">
                        <v-text-field
                          :label="$t('SPACE.EDIT.WORD.URL')"
                          solo
                          counter="30"
                          v-model="alias"
                          :prefix="`${$frontPageURL}/`"
                          :rules="[
                            (v) =>
                              $rules.required(
                                v,
                                $t('SPACE.EDIT.INPUT.ALERT.URL_IS_REQUIRED')
                              ),
                            (v) =>
                              /^[a-zA-Z0-9-_]+$/.test(v) ||
                              $t(
                                'SPACE.EDIT.INPUT.ALERT.URL_NOT_CONFORM_RULES'
                              ),
                            (v) => $rules.maxLength(v, 30)
                          ]"
                          :error-messages="aliasError"
                          :hint="
                            $t(
                              'SPACE.EDIT.INPUT.REMIND.NAMES_AUTOMATICALLY_LOWERCASE'
                            )
                          "
                        >
                          <template #append v-if="isCheckingAlias">
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </template>
                        </v-text-field>
                      </div>
                    </div>
                  </div>
                  <div class="w100p">
                    <SizeBox height="6" />
                    <v-divider></v-divider>
                    <SizeBox height="12" />
                  </div>
                  <v-card-actions class="flex-center pa-4 build_btn">
                    <v-btn depressed @click="closePop">
                      {{ $t('COMMON.WORD.CANCEL') }}
                    </v-btn>
                    <SizeBox width="24" />
                    <v-btn
                      color="primary"
                      depressed
                      @click="submit"
                      :loading="isCheckingAlias"
                    >
                      {{ $t('COMMON.WORD.CREATE') }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-row>
            </v-scale-transition>
            <v-scale-transition>
              <v-row v-if="computedRenderInfoCard == 'free'">
                <v-col cols="12" class="pa-8 pt-0" style="text-align: center">
                  <h2 style="font-size: 1.375em; font-weight: 400">
                    {{ $t('SPACE.COPYWRITING.INSUFFICIENT_PRIVILEGES') }}
                  </h2>
                  <SizeBox height="18" />
                  <p
                    class="text-16px"
                    style="letter-spacing: 0.03em; color: #dadada"
                  >
                    {{ $t('SPACE.COPYWRITING.3D_EDITMODE_IS_PREMIUM') }}
                    <br />
                    {{ $t('SPACE.COPYWRITING.PLEASE_UPGRADE_YOUR_PLAN') }}
                  </p>
                  <SizeBox height="18" />
                  <v-btn
                    color="primary"
                    class="w100p"
                    height="46"
                    depressed
                    to="/update-account"
                  >
                    <!-- 升級 -->
                    {{ this.$t('COMMON.WORD.UPGRADE') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-scale-transition>
          </v-card>
        </v-dialog>
      </Async>
    </div>
  </div>
</template>
<script>
import sample0 from '@/assets/images/exhibition/create_space/sample0.png';
import sample1 from '@/assets/images/exhibition/create_space/sample1.png';
import sample2 from '@/assets/images/exhibition/create_space/sample2.png';
import sample3 from '@/assets/images/exhibition/create_space/sample3.png';
import { addExhibition, checkExhibitionsAlias } from '@/api/panel/exhibitions';
import { mapGetters } from 'vuex';
export default {
  name: 'creat_space',
  data: () => ({
    loading: false,
    show: false,
    dialog: false,
    name: '',
    alias: '',
    isCheckingAlias: false,
    aliasError: null,
    spaceData: [
      {
        title: '簡易模式',
        description:
          '透過平面圖新增作品來上稿，推薦給需要快速建立展覽以及入門的策展者。',
        to: '/exhibitions/theme',
        img: sample0,
        titleKey: 'SPACE.EDIT.COPYWRITING.SIMPLE_MODE',
        descriptionKey:
          'SPACE.EDIT.COPYWRITING.BY_USING_ARTWORK_RECOMMAND_ROOKIE'
      },
      {
        title: '自由編輯模式',
        description:
          '使用 3D 場景編輯器 VSNOVA，可以自由設計場景，適合進階策展者使用。',
        to: 'createPop',
        img: sample1,
        titleKey: 'SPACE.EDIT.COPYWRITING.FREE_EDIT_MODE',
        descriptionKey: 'SPACE.EDIT.COPYWRITING.USE_VSNOVA_FREE_CREATE'
      }
      // {
      //   title: '實境模式',
      //   description:
      //     '在 Matterport 建立 3D 掃描實境後，導進 Virsody 作為虛擬空間。',
      //   to: '',
      //   img: sample2
      // },
      // {
      //   title: '相容模式',
      //   description:
      //     '只要上傳連結即可將外部展間相容於 Virsody 平台中(僅供管理員使用)',
      //   to: '',
      //   img: sample3
      // }
    ]
  }),
  computed: {
    ...mapGetters({
      Team: 'auth/getTeam'
    }),
    permissionAssets() {
      return this?.Team?.permissionAsset || {};
    },
    teamGroup() {
      return this?.permissionAssets?.teamGroup || {};
    },
    computedRenderInfoCard() {
      switch (this.teamGroup.alias) {
        case 'creator':
          return 'creator';
        case 'advanced':
          return 'advanced';
        case undefined:
          return 'free';
        default:
          return 'customized';
      }
    },
    dialogWidth() {
      if (this.computedRenderInfoCard == 'free') return 440;
      else return 620;
    }
  },
  methods: {
    goTo(url) {
      if (url == 'createPop') this.dialog = true;
      else this.$router.push(url);
    },
    closePop() {
      this.dialog = false;
      this.name = '';
      this.alias = '';
    },
    async submit() {
      let flag = true;
      console.log(!this.$refs.form.validate());
      if (!this.$refs.form.validate()) flag = false;
      if (!(await this.checkAlias())) flag = false;
      // if (!this.$refs.ScenePicker.$validate()) flag = false;
      if (!flag) return;

      const { error } = await addExhibition({
        name: this.name,
        alias: this.alias.toLowerCase(),
        artworkType: 'advanced'
      });

      if (!error) {
        this.$toast(this.$t('SPACE.EDIT.TOAST.SUCCESS.CREATE_SUCCESFUL'));
        this.$router.replace({ name: 'exhibitions' });
      } else {
        this.$toast.error('創建失敗');
      }
    },
    async checkAlias() {
      this.aliasError = null;
      this.isCheckingAlias = true;

      const { isAllowed } = await checkExhibitionsAlias({
        alias: this.alias
      });
      if (!isAllowed) {
        this.aliasError = this.$t(
          'SPACE.EDIT.INPUT.ALERT.URL_ALREADY_USED_PLEASE_TRY_ANOTHER'
        );
      }
      this.isCheckingAlias = false;

      return isAllowed;
    }
  }
};
</script>
<style lang="scss" scoped>
.create_space {
  ::v-deep .v-card {
    button {
      background-color: transparent !important;
      color: $primary;
      &::before {
        display: none;
      }
    }
    .v-icon--right {
      background-color: $primary;
      border-radius: 50px;
      width: 22px;
      height: 22px;
      color: #fff;
    }
    .v-image {
      width: calc(100% - 32px);
      margin: auto;
    }
  }
}
.preview_container {
  padding: 2% 2.5%;
  border: 24px;
  background-color: $neutral800;
  .preview {
    padding: 28%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 0.5%;
    iframe,
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    img {
      object-fit: cover;
    }
    .embed-container {
      position: absolute;
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;
      max-width: 100%;
      width: 100%;
      left: 0;
      top: 0;
    }
  }
  .slide-card {
    &:nth-of-type(1) {
      margin-left: 0 !important;
    }
    &:nth-last-child(1) {
      margin-right: 0 !important;
    }
  }
  .detail {
    .v-card__title {
      font-size: 1.25rem;
      width: calc(100% - 37px);
      label {
        font-size: 12px;
        background-color: $primary500;
        border-radius: 4px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        padding: 0 6px;
      }
    }
    .v-chip {
      i {
        font-size: 20px;
      }
    }
    .update_tip {
      text-align: center;
      font-size: 12px;
      color: $neutral300;
      span {
        color: $primary300;
      }
    }
  }
}
.set_detail {
  .subtitle {
    color: $neutral200;
  }
  .build_btn {
    width: 100%;
    margin-bottom: 10px;
    button {
      width: calc(50% - 12px);
      height: 41px;
      &:nth-of-type(1) {
        color: $neutral200;
        background-color: $neutral600;
      }
    }
  }
  ::v-deep {
    .v-input {
      .v-input__control {
        position: relative;
      }
      .v-input__slot {
        background-color: $neutral700;
        .v-label {
          color: $neutral400;
        }
      }
      .v-text-field__details {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        .v-messages {
          display: none;
        }
      }
    }
  }
}
::v-deep {
  .v-dialog {
    overflow: hidden;
    max-width: 1116px;
    &.set_detail {
      max-width: 620px;
    }
  }
  .v-slide-group__prev,
  .v-slide-group__next {
    display: none;
  }
  .v-slide-group__wrapper {
    overflow-x: auto; /* Enables the horizontal scrollbar */
    /* Next lines hides scrollbar in different browsers for styling purposes */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .v-slide-group__wrapper::-webkit-scrollbar {
    display: none; /* Chrome opera and Safary */
    width: 0px;
    background: transparent;
  }
}
</style>